import SpinnerDot from "../../components/SpinnerDot";
import auth from "../../firebase/auth";
import UpdateProfileForm from "../../forms/UpdateProfileForm";
import useAxiosJwtQuery from "../../hooks/useAxiosJwtQuery";

export default function MyProfile() {
  const { displayName, email } = auth.currentUser;

  const [data, refetch] = useAxiosJwtQuery(`/users/${email}`);

  return (
    <section>
      <div class="hero">
        <div class="hero-content flex-col">
          <div class="text-center lg:text-left">
            <h1 class="text-5xl font-bold">My Profile</h1>
          </div>

          {!data ? (
            <SpinnerDot />
          ) : (
            <>
              <div class="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-100">
                <div class="card-body">
                  <div class="form-control">
                    <label class="label">
                      <span class="label-text">Email</span>
                    </label>

                    <input
                      type="text"
                      name="email"
                      value={email}
                      class="input input-bordered"
                      disabled
                    />
                  </div>

                  <div class="form-control">
                    <label class="label">
                      <span class="label-text">Name</span>
                    </label>

                    <input
                      type="text"
                      name="name"
                      value={displayName}
                      class="input input-bordered"
                      disabled
                    />
                  </div>
                </div>
              </div>

              <UpdateProfileForm data={data} refetch={refetch} />
            </>
          )}
        </div>
      </div>
    </section>
  );
}
